import React, { Fragment, Component } from 'react'
import {
    Row, Col,Button, Label,Table
} from "reactstrap"
import classnames from 'classnames'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { AvForm, AvField, AvGroup, AvCheckboxGroup, AvCheckbox, AvInput } from "availity-reactstrap-validation"
import CustomSelect from '../../../../../helpers/ui/CustomSelect'
import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../../services/apiResponse'

import IndexBloc from '../../Index/Blocs/IndexBloc'
import UpdateBloc from '../../Update/Blocs/UpdateBloc'

class TanggungjawabComponent extends Component {

    updateBloc = new UpdateBloc()
    indexBloc = new IndexBloc()
    source
    timer
    constructor(props) {
        super(props)
        this.state = {
            detail: [],
            detailTanggungjawab: [
                {
                    id: 1,
                    desc: '',
                }
            ],
            dataForm: {},
            isLoading: 0,
        }
    }

    reformatdesc = (raw) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["id"] = data.responsibility_id;
          newObj["desc"] = data.responsibility_description;
          return newObj;
        });
    }

    toggle = tab => {
        if(this.state.activeTab !== tab) this.setState({activeTab:tab});
    }

    loadDetailTanggungjawab = async () => {
        const query = {
            uuid: this.props.uuid
        }

        await this.updateBloc.fetchResponsibility(query)
    }

    componentDidMount() {
        this.loadDetailTanggungjawab()
        console.log(this.state.detailTanggungjawab)
        
        this.updateBloc.detailTanggungjawabChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        console.log('tanggungjawab')
                        console.log(response)
                        if (response.length > 0) {
                            this.setState({ detailTanggungjawab: this.reformatdesc(response) })
                        }
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })


    }

    componentWillUnmount() {
        this.updateBloc.positionInfoChannel?.unsubscribe()
        this.updateBloc.detailTanggungjawabChannel?.unsubscribe()
    }

    render() {
        const { detail, list } = this.state
        return (
            <Fragment>
                <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) => this.handlerOnSubmitdesc(e, values)}
                >
                    <Col md="12">
                            <div className="row" style={{padding:'15px'}}>
                                <div className="col-md-5 text-bold">
                                    <b>Tanggung Jawab</b>
                                </div>
                            </div>
                        </Col>
                    <Row className="mb-12">
                        <AvField
                            name="tipe"
                            type="hidden"
                            id="tipe"
                            value="1"
                        />
                        <Table className="table-bordered">
                            <thead className="bg-default" style={{background:'lavender'}}>
                                <tr>
                                    <th>Uraian Tanggung Jawab</th>
                                </tr>
                            </thead>
                            <tbody>
                                    {
                                this.state.detailTanggungjawab.map((data, index) => {
                                    return (
                                <tr>
                                    <td>
                                        {data.desc}
                                    </td>
                                </tr>
                                    )    
                                })
                            }
                            </tbody>
                        </Table>
                        <AvField
                            name="responsibility_position_uuid"
                            type="hidden"
                            value={this.props.uuid}
                            // validate={{ required: { value: true } }}
                            readOnly={true}
                        />
                        
                    </Row>
                    <Row className="mb-3" style={{padding:'25px'}}>
                        <Col md="3"></Col>
                        <Col md="9">
                            <Link to="/master/syarat_jabatan.html">
                                <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                            </Link>
                            {' '}
                            
                        </Col>
                    </Row>
                </AvForm>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/master/syarat_jabatan.html'/>
                : null }
            </Fragment>
        )
    }


}

export default TanggungjawabComponent
